export default "__VITE_ASSET__XQO1xHZf__"